export default __webpack_public_path__ + "static/media/BLANK OR Surgical Boarding Form (Macomb and Oakland).ab681707.pdf";